export const landingStatData = [
    {
        title: "Total value locked",
        data: "30,842,627 USDC",
    },
    {
        title: "APY 90d",
        data: "12.7%",
    },
    {
        title: "Credit outstanding",
        data: "30,836,160 USDC",
    },
]